import React from 'react';
import './LoadingSkeleton.css';

function LoadingSkeleton({
  variant = 'paragraph',
  lines = 3,
  width,
  height = 14,
  circleSize = 40,
  label = 'Loading',
  className = '',
}) {
  if (variant === 'line') {
    return (
      <div className={`loading-skeleton loading-skeleton--inline ${className}`.trim()}>
        <div
          className="loading-skeleton__line"
          style={{ width: width || '100%', height }}
          aria-hidden="true"
        />
      </div>
    );
  }

  if (variant === 'circle') {
    return (
      <div
        className={`loading-skeleton__circle ${className}`.trim()}
        style={{ width: circleSize, height: circleSize }}
        aria-hidden="true"
      />
    );
  }

  if (variant === 'paragraph') {
    const lineWidths = Array.from({ length: lines }, (_, i) =>
      i === lines - 1 ? '60%' : '100%'
    );
    return (
      <div
        className={`loading-skeleton ${className}`.trim()}
        role="status"
        aria-label={label}
      >
        {lineWidths.map((w, i) => (
          <div
            key={i}
            className="loading-skeleton__line"
            style={{ width: width || w, height }}
          />
        ))}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div
        className={`loading-skeleton ${className}`.trim()}
        role="status"
        aria-label={label}
      >
        <div className="loading-skeleton__line" style={{ width: '40%', height: 16 }} />
        <div className="loading-skeleton__line" style={{ width: '100%', height: 80 }} />
        <div className="loading-skeleton__line" style={{ width: '60%', height: 12 }} />
      </div>
    );
  }

  return null;
}

export default LoadingSkeleton;
